module.exports = __webpack_public_path__ + "img/motorola.7b6ba866.svg";